import { getPaginated } from '@/api/base'

const categoryValuesApi = {
  get: async (context, category) => {
    const response = await getPaginated({
      path: `category_values/${context}/${category}`,
      valuePath: 'category_values',
    })
    return response.success ? response.values : []
  },
}

export default categoryValuesApi
